import * as Yup from 'yup';

export const initialValues = {
  vendor: "",
  name: "",
  identity: {
    number: "",
    type: undefined, //1=ktp,2=kitas, 3=paspor
    file: "" //tbd
  },
  nationality: undefined, // wni/wna
  gender: undefined, //L/P
  blood_type: undefined,
  health: {
    status: undefined, // 1=fit, 2=non fit, 3=fit with note
    notes: "", // jika status selain 3, kasih nilai null
    file: "" //tbd
  },
  department: undefined, //1=Project Management, 2=Engineeering, 3=Procurement
  position: undefined, //1=Manager, 2=Koordinator, 3=HSE, 99=Lainnya
  email: "",
  phone: "",
  emergency_contact: "",
  education: undefined, //1=SD, 2=SMP, 3=SMA/SMK, 4=D3, 5=S1/D4, 6=S2, 7=S3, 99=Lainnya
  work_experience_pp_start_date: "", //2012-04-23 (pengalaman kerja PP)
  work_experience_pp_end_date: "",
  work_experience_nonpp_start_date: "", //2012-04-23 (pengalaman kerja Non-PP)
  work_experience_nonpp_end_date: "",
  job_specialization: undefined,
  skills: [], //isinya bisa banyak je, disimpen di passport_skills
  skills_file: [], // array of { file, tgl_terbit, tgl_expired }
  sickness: [], //isinya bisa banyak, disimpen di passport_sickness
  training_competency: [],
  project: {
    //simpen di passport_project
    id: undefined,
    division: undefined, //1=Reguler, 2=EPC
    start: "",
    end: ""
  }
};

export const registerSchema = Yup.object().shape({
  vendor: Yup.mixed().nullable(true).required("Vendor wajib diisi"),
  name: Yup.string().nullable(true).required("Nama wajib diisi"),
  identity: Yup.object().shape({
    number: Yup.string().nullable(true).required("Identitas diri wajib diisi"),
    type: Yup.mixed().nullable(true).required("Jenis identitas wajib diisi"),
  }),
  nationality: Yup.mixed().oneOf(['wni', 'wna']).nullable(true).required('Kebangsaan wajib diisi'),
  gender: Yup.mixed().nullable(true).required('Jenis kelamin wajib diisi'),
  blood_type: Yup.mixed().nullable(true).required('Golongan darah wajib diisi'),
  health: Yup.object().shape({
    status: Yup.mixed().nullable(true).required('Status kesehatan wajib diisi'),
    notes: Yup.mixed().when('status', {
      is: value => value===3,
      then: Yup.mixed().nullable(true).required('Catatan kesehatan wajib diisi'),
      otherwise: Yup.mixed().nullable(true)
    })
  }),
  department: Yup.mixed().nullable(true).required('Departemen wajib diisi'),
  position: Yup.mixed().nullable(true).required('Level Jabatan wajib diisi'),
  email: Yup.string().nullable(true).required('Email wajib diisi').email('Format email tidak valid'),
  phone: Yup.mixed().nullable(true).required('HP wajib diisi'),
  emergency_contact: Yup.mixed().nullable(true).required('Kontak darurat wajib diisi'),
  education: Yup.mixed().nullable(true).required('Pendidikan terakhir wajib diisi'),
  work_experience_pp_start_date: Yup.mixed().nullable(true).required('Tanggal mulai bekerja PP wajib diisi'),
  work_experience_pp_end_date: Yup.mixed().nullable(true).required('Tanggal selesai bekerja PP wajib diisi'),
  work_experience_nonpp_start_date: Yup.mixed().nullable(true).required('Tanggal mulai bekerja Non-PP wajib diisi'),
  work_experience_nonpp_end_date: Yup.mixed().nullable(true).required('Tanggal selesai bekerja Non-PP wajib diisi'),
  project: Yup.object().shape({
    id: Yup.mixed().nullable(true).required('Proyek wajib diisi'),
    division: Yup.mixed().nullable(true).required('Divisi operasi wajib diisi'),
    start: Yup.mixed().nullable(true).required('Tanggal mulai wajib diisi'),
    end: Yup.mixed().nullable(true).required('Tanggal berakhir wajib diisi'),
  }),
  skills: Yup.array().min(1, "Kompetensi wajib diisi"),
  sickness: Yup.array(),
  training_competency: Yup.array(),
  skills_file: Yup.array().of(
    Yup.object().shape({
      file: Yup.mixed().nullable(true),
      error: Yup.string()
        .nullable(true)
        .test(
          'noFileError',
          'Terdapat file yang melebihi batas ukuran maksimal',
          (value) => !value
        ),
      tgl_terbit: Yup.string().nullable(true),
      tgl_expired: Yup.string().nullable(true),
    })
  ),
});

export const updateSchema = Yup.object().shape({
  vendor: Yup.mixed().nullable(true).required("Vendor wajib diisi"),
  name: Yup.string().nullable(true).required("Nama wajib diisi"),
  identity: Yup.object().shape({
    number: Yup.string().nullable(true).required("Identitas diri wajib diisi"),
    type: Yup.mixed().nullable(true).required("Jenis identitas wajib diisi"),
  }),
  nationality: Yup.mixed().oneOf(['wni', 'wna']).nullable(true).required('Kebangsaan wajib diisi'),
  gender: Yup.mixed().nullable(true).required('Jenis kelamin wajib diisi'),
  blood_type: Yup.mixed().nullable(true).required('Golongan darah wajib diisi'),
  health: Yup.object().shape({
    status: Yup.mixed().nullable(true).required('Status kesehatan wajib diisi'),
    notes: Yup.mixed().when('status', {
      is: value => value===3,
      then: Yup.mixed().nullable(true).required('Catatan kesehatan wajib diisi'),
      otherwise: Yup.mixed().nullable(true)
    })
  }),
  department: Yup.mixed().nullable(true).required('Departemen wajib diisi'),
  position: Yup.mixed().nullable(true).required('Level Jabatan wajib diisi'),
  email: Yup.string().nullable(true).required('Email wajib diisi').email('Format email tidak valid'),
  phone: Yup.mixed().nullable(true).required('HP wajib diisi'),
  emergency_contact: Yup.mixed().nullable(true).required('Kontak darurat wajib diisi'),
  education: Yup.mixed().nullable(true).required('Pendidikan terakhir wajib diisi'),
  // work_experience: Yup.mixed().nullable(true).required('Pengalaman bekerja wajib diisi'),
  work_experience_pp: Yup.mixed().nullable(true).required('Pengalaman bekerja PP wajib diisi'),
  work_experience_nonpp: Yup.mixed().nullable(true).required('Pengalaman bekerja Non-PP wajib diisi'),
  // project: Yup.object().shape({
  //   id: Yup.mixed().nullable(true).required('Proyek wajib diisi'),
  //   division: Yup.mixed().nullable(true).required('Divisi operasi wajib diisi'),
  //   start: Yup.mixed().nullable(true).required('Tanggal mulai wajib diisi'),
  //   end: Yup.mixed().nullable(true).required('Tanggal berakhir wajib diisi'),
  // }),
  // skills: Yup.array().min(1, "Kompetensi wajib diisi"),
  // sickness: Yup.array(),
  // training_competency: Yup.array(),
});

export const verificationSchema = Yup.object().shape({
  // level: Yup.mixed().required("Level harus diisi").nullable(true),
  // induction_date: Yup.mixed().required("Tanggal harus diisi").nullable(true),
  induction_status: Yup.mixed().required("Status harus diisi").nullable(true),
  // quality: Yup.mixed().required("Kualitas harus diisi").nullable(true),
  approval: Yup.mixed().required("Persetujuan PM harus diisi").nullable(true),
});

export const inductionScheduleSchema = Yup.object().shape({
  level: Yup.mixed().required("Level harus diisi").nullable(true),
  induction_date: Yup.mixed().required("Tanggal harus diisi").nullable(true),
  quality: Yup.mixed().required("Kualitas harus diisi").nullable(true)
});

export const projectSwitchSchema = Yup.object().shape({
  project: Yup.object().shape({
    id: Yup.mixed().nullable(true).required('Proyek wajib diisi').notOneOf([Yup.ref('before')],"Anda tidak bisa memilih proyek yang sama dengan sebelumnya"),
    division: Yup.mixed().nullable(true).required('Divisi operasi wajib diisi'),
    start: Yup.mixed().nullable(true).required('Tanggal mulai wajib diisi'),
    end: Yup.mixed().nullable(true).required('Tanggal berakhir wajib diisi'),
  })
});